const rootStyles = {
  borderBottom: ({ palette }) => `1px solid ${palette.divider}`,
  borderTop: ({ palette }) => `1px solid ${palette.divider}`,
};

const nameStyles = {
  flex: 1,
  fontWeight: 'normal',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
};

const itemStyles = {
  '&&&': {
    color: ({ palette }) => palette.text.primary,
  },
  display: 'flex',
  flexDirection: 'column',
  borderLeft: '2px solid transparent',
  width: '100%',
  padding: '4px 10px 4px 30px',
  '& .delete-btn': {
    opacity: 0,
    transition: 'opacity 200ms linear',
    pointerEvents: 'none',
  },
  '&:hover .delete-btn': {
    opacity: 1,
    pointerEvents: 'all',
  },
};

const selectedStyles = {
  '&&&': {
    borderLeftColor: ({ palette }) => palette.secondary.main,
    color: ({ palette }) => palette.secondary.main,
    backgroundColor: ({ palette }) => palette.action.selected,
  },
  opacity: 1,
};

const tagStyles = {
  marginLeft: 10,
};

export const getStyles = () => ({
  root: rootStyles,
  name: nameStyles,
  item: itemStyles,
  selected: selectedStyles,
  tag: tagStyles,
  itemRoot: { ...itemStyles, ...rootStyles },
  itemRootSelected: { ...itemStyles, ...rootStyles, ...selectedStyles },
});

export const dateContainerStyles = {
  height: '36px',
};
